module.exports = __webpack_public_path__ + "img/img_sjgl_blzn_n@2x.7412a4a4.png";